import React from "react";
import { Translate as T } from "react-redux-i18n";
import styles from "./Dialog.css";
import HeadingPaper from "../HeadingPaper/HeadingPaper";

const Dialog = ({ onClose = false, heading = null, children }) => (
  <div className={styles.dialog}>
    {heading && (
      <h1 className={styles.heading}>
        <HeadingPaper>{heading}</HeadingPaper>
      </h1>
    )}
    {children}
    {onClose && (
      <button onClick={onClose} className={styles.close}>
        <T value="common.close" />
      </button>
    )}
  </div>
);

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js